import request from "project-config/services/request/request";
import { Project } from "../types";

const ProjectAPI = {
  editProject(params: Project.Params.Form) {
    return request.post("/api/rendering/task/common/editProject", params);
  },
  addProject(params: Project.Params.Form) {
    return request.post("/api/rendering/task/common/operateUserLabel", params);
  },
  queryLabelUser(params: { label: string }) {
    return request.post("/api/rendering/task/common/queryLabelUser", params);
  },
  queryDingTalkDeptByUser() {
    return request.post("/api/rendering/user/queryDingTalkDeptByUser");
  },
};
export default ProjectAPI;
